
import * as React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import SendIcon from '@material-ui/icons/Send';
import { LinearProgress, FormControl, InputLabel, Select, MenuItem, Typography, TablePagination, TableSortLabel, TextField, IconButton, Tooltip } from '@material-ui/core';

import './MarketShareBookstoreCategoryRanking.scss';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { QUERY_FILTER_MARKET_BOOKSTORE, QueryFilter } from 'src/component/shared';
import { MoneyLessBRL, NumberConvert, NumberLessBRL, CurrentDate, SomeDaysAgo } from 'src/services';

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreCategoryRankingPros {
}

export interface IMarketShareBookstoreCategoryRanking {
    count: number,
    dimension: number,
    dimensionName: string,
    endDate: any,
    initialDate: any,
    limit: number,
    openSnack: boolean,
    orderBy: number,
    orderByName: string,
    page: number,
    rows?: any,
    tableOrder: 'asc' | 'desc' | undefined,
    tableOrderBy: string,
    snackMessage: string,
}

interface IEnhancedTableProps {
    dimension: number;
    dimensionName: string;
    tableOrder: 'asc' | 'desc' | undefined,
    tableOrderBy: string,
    onRequestSort: (event: React.MouseEvent, property: string) => void;
}

const EnhancedTableHead = (props: IEnhancedTableProps) => {
    const { dimension, dimensionName, tableOrder, tableOrderBy, onRequestSort } = props;
    const createSortHandler = (property: string) => (event: React.MouseEvent) => {
      onRequestSort(event, property);
    };
  
    return (
        <TableHead>
            <TableRow>
                <TableCell colSpan={2}>{dimensionName}</TableCell>
                
                {dimension === 2 && <TableCell>Fabricante</TableCell>}
                {dimension === 2 && <TableCell>Categoria</TableCell>}
                
                <TableCell
                    sortDirection={tableOrderBy === 'your' ? tableOrder : false}
                >
                    <TableSortLabel
                        active={tableOrderBy === 'your'}
                        direction={tableOrderBy === 'your' ? tableOrder : 'desc'}
                        onClick={createSortHandler('your')}
                    >
                        Loja
                    </TableSortLabel>
                </TableCell>
                <TableCell>Share</TableCell>
                <TableCell
                    sortDirection={tableOrderBy === 'market' ? tableOrder : false}
                >
                    <TableSortLabel
                        active={tableOrderBy === 'market'}
                        direction={tableOrderBy === 'market' ? tableOrder : 'desc'}
                        onClick={createSortHandler('market')}
                    >
                        Mercado
                    </TableSortLabel>
                </TableCell>
            </TableRow>
        </TableHead>
    );
}

const QUERY_FILTER_MARKET_BOOKSTORE_RANKING = gql`
query marketCategoryBookstoreRanking($customFilter:  MarketShareCustomFilter) {
    marketCategoryBookstoreRanking(marketShareCustomFilter: $customFilter) {
        dimension,
        market_value,
        your_value,
        publisher,
        category
    },
    marketCategoryBookstoreRankingCount(marketShareCustomFilter: $customFilter)
}`;

const dimensionsSelect : any[] = [
    {name: 'Categoria', value:0},
    {name: 'Fabricante', value:1},
    {name: 'Produto', value:2}
];

const ordenationsSelect : any[] = [
    {name: 'Faturamento', value:0},
    {name: 'Volume', value:1}
];


export class MarketShareBookstoreCategoryRanking
  extends React.Component<IMarketShareBookstoreCategoryRankingPros, IMarketShareBookstoreCategoryRanking> {

  constructor(props: IMarketShareBookstoreCategoryRankingPros) {
    super(props);

    const finalDate = CurrentDate();
    const initDate = SomeDaysAgo(32);

    this.state = {
        count: 1000,
        dimension: 0,
        dimensionName: 'Categoria',
        endDate: finalDate,
        initialDate: initDate,
        limit: 100,
        openSnack: false,
        orderBy: 0,
        orderByName: 'Faturamento',
        page: 0,
        rows: [],
        snackMessage: "",
        tableOrder: 'desc',
        tableOrderBy: 'your',
    }

    this.handleSnackClose = this.handleSnackClose.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleTableSort = this.handleTableSort.bind(this);
  }

    public render() {
        const jsonFilter = {
            "customFilter": {
            "dimension": this.state.dimensionName,
            "endDate": this.state.endDate,
            "initialDate": this.state.initialDate,
            "limit": this.state.limit,
            "offset": (this.state.page * this.state.limit),
            "orderBy": this.state.orderByName
          }
        };

        return (
          <div>
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={this.state.openSnack}
              onClose={this.handleSnackClose}
              ContentProps={{
                'aria-describedby': 'message-id',
              }}
              message={<span id="message-id">{this.state.snackMessage}</span>}
            />
            <Query query={QUERY_FILTER_MARKET_BOOKSTORE} notifyOnNetworkStatusChange={true}>
            {({ loading: loadingC, error: errorC, data: cache, client: clientC, refetch: refetchC}) => (
              <Query query={QUERY_FILTER_MARKET_BOOKSTORE_RANKING}
               variables={QueryFilter.getFilterMarketBookstore(clientC, jsonFilter, [], false)}>
                {({ loading, error, data, client, refetch}) => {
                    return (
                        <Grid item={true} xs={12}>
                            <Paper className="publisher-sale-block panel-block market-bookstore-category-ranking-panel">
                                <Typography variant="headline" className="panel-title" component="title">
                                    Campeões de Vendas
                                </Typography>
                                <Grid container={true} spacing={16} className="market-bookstore-category-ranking-header">
                                    <Grid item={true} xs={6}>
                                        <FormControl required={true} className="width-100" >
                                            <InputLabel id="priority-select-required-label">Dimensão</InputLabel>
                                            <Select
                                                id="priority-select-required"
                                                inputProps={{
                                                    id: 0,
                                                    name: 'dimension',
                                                }}
                                                value={this.state.dimension}
                                                onChange={this.handleChangeSelect}
                                            >
                                                {
                                                    dimensionsSelect.map((dm:any, key:number) => (
                                                        <MenuItem value={dm.value}>{dm.name}</MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item={true} xs={6}>
                                        <FormControl required={true} className="width-100" >
                                            <InputLabel id="priority-select-required-label">Ordenação</InputLabel>
                                            <Select
                                                id="priority-select-required"
                                                inputProps={{
                                                    id: 0,
                                                    name: 'orderBy',
                                                }}
                                                value={this.state.orderBy}
                                                onChange={this.handleChangeSelect}
                                            >
                                                {
                                                    ordenationsSelect.map((order:any, key:number) => (
                                                        <MenuItem value={order.value}>{order.name}</MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item={true} xs={12}>
                                        <form onSubmit={this.requestByDate.bind(this, refetch, refetchC, clientC)}>
                                        <Grid container={true} spacing={16} className="market-bookstore-category-ranking-header">
                                        <Grid item={true} xs={6}>
                                            <TextField
                                                defaultValue={this.state.initialDate}
                                                id="initialDate"
                                                label="Data inicial"
                                                type="date"
                                                required={true}
                                                InputLabelProps={{
                                                shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item={true} xs={4}>
                                            <TextField
                                                defaultValue={this.state.endDate}
                                                id="endDate"
                                                label="Data final"
                                                type="date"
                                                required={true}
                                                InputLabelProps={{
                                                shrink: true,
                                                }}
                                            />
                                        </Grid>
                                            <IconButton type="submit"  color="primary" >
                                                <Tooltip title="Pesquisar">
                                                    <SendIcon />
                                                </ Tooltip>
                                            </IconButton>
                                        </Grid>
                                        </form>
                                    </Grid>
                                </Grid>
                                <div className="analytical-table">
                                    {loading ? <LinearProgress /> :<div><Table>
                                        <EnhancedTableHead
                                            dimension={this.state.dimension}
                                            dimensionName={this.state.dimensionName}
                                            tableOrder={this.state.tableOrder}
                                            tableOrderBy={this.state.tableOrderBy}
                                            onRequestSort={this.handleTableSort}
                                        />
                                        
                                        <TableBody>
                                            {data && data.marketCategoryBookstoreRanking ? 
                                                this.orderTable(data.marketCategoryBookstoreRanking).map((row: any, key: number) => {
                                                    const yourValue = this.state.orderBy === 0 ? MoneyLessBRL(row.your_value) : NumberLessBRL(row.your_value);
                                                    const marketValue = this.state.orderBy === 0 ? MoneyLessBRL(row.market_value) : NumberLessBRL(row.market_value);
                                                    const share = (NumberConvert(row.your_value)*100/NumberConvert(row.market_value)).toFixed(1)+'%'
                                                    return (
                                                        <TableRow key={key}>
                                                            <TableCell className="padding-left">{ (1 + key) + (this.state.page * this.state.limit) }</TableCell>
                                                            <TableCell>{row.dimension}</TableCell>

                                                            {this.state.dimension === 2 && <TableCell>{row.publisher}</TableCell>}
                                                            {this.state.dimension === 2 && <TableCell>{row.category}</TableCell>}
                                                            
                                                            <TableCell className="analytical-total">{yourValue}</TableCell>
                                                            <TableCell className="analytical-total">{share}</TableCell>
                                                            <TableCell className="analytical-total">{marketValue}</TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                                :<div/>
                                            }
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        page={this.state.page}
                                        count={data.marketCategoryBookstoreRankingCount ? 
                                            data.marketCategoryBookstoreRankingCount : this.state.count}
                                        rowsPerPage={this.state.limit}
                                        rowsPerPageOptions={[]}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={undefined}
                                    />
                                    </div>}
                                </div>
                            </Paper>
                        </Grid>
                    );
                }}
              </Query>
            )}
          </Query>
          </div>
        );
    }

    public handleSnackClose(ev: any) {
        this.setState({
            openSnack: false,
        });
    }

    public requestByDate(refetch: any, refetchC: any, clientC: any, ev: any) {
        ev.preventDefault();
        QueryFilter.updateMutationMarketBookstore();
        this.setState({
            endDate: ev.target.endDate.value,
            initialDate: ev.target.initialDate.value,
        });
    }

    private handleChangeSelect = (event: any) => {
        const state : any = Object.assign({}, this.state);
        state[event.target.name] = event.target.value;
        if("dimension"===event.target.name) {
            const dimensionSelected : any[] = dimensionsSelect.filter((ds:any)=> {
                return ds.value === event.target.value;
            });

            if(dimensionSelected && dimensionSelected.length > 0 && dimensionSelected[0].name && dimensionSelected[0].name.length > 0) {
                state.dimensionName = dimensionSelected[0].name;
            }
            state.page = 0;
        }

        if("orderBy"===event.target.name) {
            const orderBySelected : any[] = ordenationsSelect.filter((ds:any)=> {
                return ds.value === event.target.value;
            });

            if(orderBySelected && orderBySelected.length > 0 && orderBySelected[0].name && orderBySelected[0].name.length > 0) {
                state.orderByName = orderBySelected[0].name;
            }
        }
        this.setState(state);
    };

    private handleChangePage(ev: any, pageParam: number) {
        if (pageParam !== this.state.page) {
          this.setState({ page: pageParam });
        }
    }
    
    private handleTableSort(event: React.MouseEvent, property: string) {
        const isDesc = this.state.tableOrderBy === property && this.state.tableOrder === 'desc';
        const newOrder = isDesc ? 'asc' : 'desc';
        this.setState({
            tableOrder: newOrder,
            tableOrderBy: property
        });
        return undefined;
    }

    private orderTable(data:any[]) {
        data = data.sort((obj1:any, obj2:any) => {
            let val1 = 0;
            let val2 = 0;
            if(this.state.tableOrderBy==='market') {
                val1 = NumberConvert(obj1.market_value);
                val2 = NumberConvert(obj2.market_value);
            } else {
                val1 = NumberConvert(obj1.your_value);
                val2 = NumberConvert(obj2.your_value);
            }

            if(this.state.tableOrder === 'asc') {
                return val1 - val2;
            } else {
                return val2 - val1
            }
        });
        return data;
    }
}



// WEBPACK FOOTER //
// ./src/component/market/bookstore/categoryShare/ranking/MarketShareBookstoreCategoryRanking.tsx